import { SrtState, SrtMessage } from './utils/type'

const getInitialState = (): SrtState => {
    return {
        starting: true,
        data: {},
        span: {}
    }
}

export const SrtWidgetReducer: WidgetReducerType<SrtState, SrtMessage> = (state = getInitialState(), message) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message?.baseline && message?.type !== 'event') {
        return state
    }

    switch (message?.type) {
        case 'start':
            return {
                ...state,
                starting: true,
                data: {}
            }

        case 'event':
            const events = message?.events
            return {
                ...state,
                data: events
            }

        case 'span':
            return {
                ...state,
                span: { ...state.span, [message?.layer]: message?.events }
            }
    }
    return state
}
